import { Pipe, PipeTransform, ViewChild } from '@angular/core';
import { ParticipationComponent } from '../participation/participation.component';
import { Questions } from '../common-class/questions';
import { Group, Matrix } from '../common-class/pages';

@Pipe({
  name: 'getmatrixgroup'
})
export class MatrixGroupPipe implements PipeTransform {

  constructor(private participation: ParticipationComponent) { }

  transform(matrix: Matrix, args?: any): Group[] {
    return this.participation.GetGroupDatas(matrix)
  }
}
